module.exports = __webpack_public_path__ + "img/balti-curry.590c690d.jpeg";